module.exports = __webpack_public_path__ + "assets/img/微信公众号-c478a561.png";